import React from 'react';
import { FadeIn } from '../FadeIn';
import { Check, X } from 'lucide-react';
export function ForWhomAHA() {
  const isFor = ['Femei care se simt copleșite de emoții și vor instrumente rapide pe care să le folosească pe moment, nu peste 6 luni', 'Femei care au trecut sau trec printr-o perioadă grea și caută ceva concret la care să se agațe, între ședințele de terapie sau în loc de ele', 'Femei care vor un prim pas blând de reconectare cu ele însele, fără să se înscrie direct într-un program lung'];
  const isNotFor = ['Pentru cine caută soluții rapide de tipul „scap de emoții în 3 zile” — emoțiile nu dispar, dar le putem aduce la un nivel în care nu te mai copleșesc', 'Pentru cine este într-o criză acută și are nevoie de intervenție specializată, nu de un curs online (în acest caz, contactează un terapeut sau un psihiatru)', 'Pentru cine nu este dispusă să acorde măcar 20 de minute pe zi pentru a asculta un audio și a completa câteva rânduri'];
  return <section className="py-20 md:py-28 bg-white overflow-hidden" data-id="element-125">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8" data-id="element-126">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12" data-id="element-127">
          <FadeIn data-id="element-128">
            <div className="bg-forest border border-forest-light rounded-[32px] p-8 md:p-12 h-full shadow-xl relative overflow-hidden" data-id="element-129">
              <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -z-10" data-id="element-130"></div>

              <h3 className="text-2xl md:text-3xl font-serif font-medium text-ivory mb-8" data-id="element-131">
                Pentru cine este acest curs
              </h3>

              <ul className="space-y-6" data-id="element-132">
                {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-133">
                    <div className="w-6 h-6 rounded-full bg-gold/20 flex items-center justify-center shrink-0 mt-1" data-id="element-134">
                      <Check className="w-4 h-4 text-gold" strokeWidth={3} data-id="element-135" />
                    </div>
                    <p className="text-[18px] text-ivory/80 leading-relaxed" data-id="element-136">
                      {item}
                    </p>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-137">
            <div className="bg-ivory border border-gold/30 rounded-[32px] p-8 md:p-12 h-full shadow-soft relative overflow-hidden" data-id="element-138">
              <div className="absolute bottom-0 right-0 w-64 h-64 bg-forest/5 rounded-full blur-3xl -z-10" data-id="element-139"></div>

              <h3 className="text-2xl md:text-3xl font-serif font-medium text-forest mb-8" data-id="element-140">
                Pentru cine <span className="italic" data-id="element-141">nu</span> este acest curs
              </h3>

              <ul className="space-y-6" data-id="element-142">
                {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-143">
                    <div className="w-6 h-6 rounded-full bg-charcoal/10 flex items-center justify-center shrink-0 mt-1" data-id="element-144">
                      <X className="w-4 h-4 text-charcoal/60" strokeWidth={3} data-id="element-145" />
                    </div>
                    <p className="text-[18px] text-charcoal/70 leading-relaxed" data-id="element-146">
                      {item}
                    </p>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}